import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ModalMenu from '../../containers/ModalMenu';
import { Link } from 'react-router-dom';
import circle from '../../img/circulogris.png';
import {
    addFriend, startFollow, stopFollow, acceptFriendRequest,
    cancelFriendRequest, deleteFriend, blockFriend, unblockFriend, seeFriendList,
} from '../../actions/friendsActions'

import {
    reportUser,
} from '../../actions/userActions'
import diammond from '../../img/diamante.png';
import { ReactComponent as MyPostIcon } from '../../img/ic_mispost.svg';
import { ReactComponent as FavoriteIcon } from '../../img/ic_favoritos.svg';
import { ReactComponent as RankingIcon } from '../../img/ic_ranking.svg';
import { ReactComponent as OptionsIcon } from '../../img/ic_opciones.svg';
import { ReactComponent as AlbumsIcon } from '../../img/ic_guardado.svg';
import { ReactComponent as CloseIcon } from '../../img/ic_cerrar.svg';
import { Translate } from '../../language';
import { getUserInfo, getUserPost, getRelationBetween } from '../../actions/userActions'

import ModalPictureProfile from '../../containers/ModalPictureProfile';
import { Switch } from 'react-router-dom'
import { RouteWithSubRoutes } from "../../config/Router";
import inMemoryJWT from '../../auth/inMemoryJwt'

import ModalReportContent from '../../containers/ReportContent/ModalReportPost';



import { ReactComponent as ProfileIcon } from '../../img/ic_perfil.svg';
import { ReactComponent as UbitacionIcon } from '../../img/ic_ubicacion.svg';
import { ReactComponent as EmailIcon } from '../../img/ic_correo.svg';
import { ReactComponent as HeartIcon } from '../../img/ic_like.svg';
import { ReactComponent as PhoneIcon } from '../../img/ic_contacto.svg';
import { ReactComponent as ProfessionalIcon } from '../../img/profesional_inicio.svg';
import calendarioImg from '../../img/calendario.png'

//import { Translate } from '../../language';
//import { getUserInfo, getUserPost, resetInfo } from '../../actions/userActions'
import { zodiac } from '../../functions/zodiacSign'


import { useParams } from "react-router-dom";
import localStorage from '../../utils/hooks/useLocalStorage';
//import inMemoryJWT from '../../auth/inMemoryJwt';



const Profile = ({ history, seeFriendList, routes, match, getUserInfo, isLoadingRelation,
                getRelationBetween, isLoadingGetUserInfo, userInfo,userCounters,isUserReported, relationBetween, addFriend,
                startFollow, stopFollow, acceptFriendRequest, cancelFriendRequest, deleteFriend, blockFriend, unblockFriend }) => {

    let userID = match.params.userID
    /* console.log(); */
    //console.log()


    const [tap, setTap] = useState('myPost')
    /* const [isTabAlbumActiveFirstTime, setIsTabAlbumActiveFirstTime] = useState(true) */
    const [isShowPikerProfilePicture, setIsShowPikerProfilePicture] = useState(false)
    const [isShowReportPost, setIsShowReportPost] = useState(false)
    const [isSendFriend, setisSendFriend] = useState(false)
    const [isSendFollow, setisSendFollow] = useState(false)
    const [isSendBlock, setisSendBlock] = useState(false)
    const [dataFriends, setdataFriends] = useState(<></>)

    const selectPikerProfile = (e) => {
        e.stopPropagation()
        setIsShowPikerProfilePicture(!isShowPikerProfilePicture)
    }

    const selectReportPost = (e) => {
        e.stopPropagation()
        setIsShowReportPost(!isShowReportPost)
    }

    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }
        inMemoryJWT.waitForTokenRefresh().then(() => {
            // console.log()
            getUserInfo(userID,true)
           // seeFriendList()
            if (userID !== localStorage().getItem("idUser"))
                getRelationBetween(userID)
            if (history.location.pathname.includes('MySaved'))
                setTap("mySaved")
            if (history.location.pathname.includes('MyAwards'))
                setTap("myAwards")
            if (history.location.pathname.includes('MyAlbums'))
                setTap("myAlbums")
            if (history.location.pathname.includes('Marks'))
                setTap("Marks")
        })

    }, [userID])

    // useEffect(() => {
    //     if (!(inMemoryJWT.getToken())) {
    //         inMemoryJWT.getRefreshedToken()
    //     }

    //     inMemoryJWT.waitForTokenRefresh().then(() => {
    //         // if (userID !== localStorage().getItem("idUser"))
    //         //     getRelationBetween(userID)
    //         // getUserInfo(userID)
    //         setTap("myPost")
    //         if (history.location.pathname.includes('MySaved'))
    //             setTap("mySaved")
    //         if (history.location.pathname.includes('MyAwards'))
    //             setTap("myAwards")
    //         if (history.location.pathname.includes('MyAlbums'))
    //             setTap("myAlbums")
    //         if (history.location.pathname.includes('Marks'))
    //             setTap("Marks")
    //     })

    // }, [userID])

    
    useEffect(() => {

        if (relationBetween) {

            if (Array.isArray(relationBetween)) {
                console.log();
                //relationBetween=relationBetween[1].social
            }
            // relationBetween=relationBetween[1].social

            const isMyUserFirst = relationBetween.firstID === match.params.userID ? true : false
            setdataFriends(<div className='modal-options'>
                <div className="modal-options-social-list">
                    <div className="row centerItems">
                        {isMyUserFirst ?
                            relationBetween.isBlockerSecond ?
                                <div onClick={() => { unblockFriend(match.params.userID, relationBetween) }} className="pointer">
                                    'Desbloquear'
                                </div>
                                : < div className="row centerItems">
                                    {relationBetween.sendRequestSecond && !relationBetween.requestStatus ?
                                        < div onClick={() => { cancelFriendRequest(match.params.userID, relationBetween) }} className="pointer">
                                            Cancelar Solicitud
                                        </div> :
                                        relationBetween.sendRequestFirst && !relationBetween.requestStatus ?
                                            <div className="row">
                                                <div onClick={() => { cancelFriendRequest(match.params.userID, relationBetween) }} className="pointer">
                                                    Rechazar solicitud
                                                </div>
                                                <div onClick={() => { acceptFriendRequest(match.params.userID, relationBetween) }} className="pointer">
                                                    Aceptar solicitud
                                                </div>
                                            </div> :
                                            <div > {
                                                relationBetween.areFriends ?
                                                    <div onClick={() => { deleteFriend(match.params.userID, relationBetween) }} className="pointer">Eliminar de amigos</div> :
                                                    <div onClick={() => {
                                                        setisSendFriend(true)
                                                        addFriend(match.params.userID, relationBetween)
                                                         }} className="pointer">Agregar a amigos</div>
                                            }</div>
                                    }
                                    <div>
                                        {
                                            relationBetween.isFollowerSecond ?
                                                <div onClick={() => { stopFollow(match.params.userID, relationBetween) }} className="pointer">Dejar de Seguir</div> :
                                                <div onClick={() => { startFollow(match.params.userID, relationBetween) }} className="pointer">Seguir</div>
                                        }
                                    </div>
                                    <div onClick={() => { blockFriend(match.params.userID, relationBetween) }} className="pointer">
                                        Bloquear
                                    </div>
                                    {
                                        !isUserReported  && <div onClick={()=>{ 
                                            console.log()
                                            setIsShowReportPost(true)}} className="pointer">
                                            Reportar
                                        </div>
                                    }
                                </div>

                            :
                            relationBetween.isBlockerFirst ?
                                <div onClick={() => { unblockFriend(match.params.userID, relationBetween) }} className="pointer">
                                    'Desbloquear'
                                </div>
                                : < div className="row centerItems">
                                    {relationBetween.sendRequestFirst && !relationBetween.requestStatus ?
                                        < div onClick={() => { cancelFriendRequest(match.params.userID, relationBetween) }} className="pointer">
                                            Cancelar Solicitud
                                        </div> :
                                        relationBetween.sendRequestSecond && !relationBetween.requestStatus ?
                                            <div className="row">
                                                <div onClick={() => { cancelFriendRequest(match.params.userID, relationBetween) }} className="pointer">
                                                    Rechazar solicitud
                                                </div>
                                                <div onClick={() => { acceptFriendRequest(match.params.userID, relationBetween) }} className="pointer">
                                                    aceptar solicitud
                                                </div>
                                            </div> :
                                            <div > {
                                                relationBetween.areFriends ?
                                                    <div onClick={() => { deleteFriend(match.params.userID, relationBetween) }} className="pointer">Eliminar de amigos</div> :
                                                    <div onClick={() => { addFriend(match.params.userID, relationBetween) }} className="pointer">Agregar a amigos</div>
                                            }</div>
                                    }
                                    <div>
                                        {
                                            relationBetween.isFollowerFirst ?
                                                <div onClick={() => { stopFollow(match.params.userID, relationBetween) }} className="pointer">Dejar de Seguir</div> :
                                                <div onClick={() => { startFollow(match.params.userID, relationBetween) }} className="pointer">Seguir</div>
                                        }
                                    </div>
                                    <div onClick={() => { blockFriend(match.params.userID, relationBetween) }} className="pointer">
                                        Bloquear {/* reportUser(
                                        { reportedEntityID: match.params.userID, description: "TEST" }
                                    ) } */}
                                    </div>
                                    {
                                        !isUserReported  && <div onClick={()=>{ 
                                            console.log()
                                            setIsShowReportPost(true)}} className="pointer">
                                            Reportar
                                        </div>
                                    }
                                    
                                   
                                </div>
                               

                        }
                    </div>
                </div>
            </div >)
        } else {
            setdataFriends(<div className='modal-options'>
                <div className="modal-options-social-list">
                    <div className="row centerItems">
                        <div className="row centerItems">
                            {isSendFriend ?
                                <div onClick={() => {
                                    setisSendFriend(false)
                                    cancelFriendRequest(match.params.userID, relationBetween)
                                }} className="pointer">Cancelar solicitud</div> :
                                <div onClick={() => {
                                    setisSendFriend(true)
                                    addFriend(match.params.userID, relationBetween)
                                }} className="pointer">Agregar a amigos</div>
                            }
                            {isSendFollow ?
                                <div onClick={() => {
                                    setisSendFollow(false)
                                    stopFollow(match.params.userID, relationBetween)
                                }} className="pointer">Dejar de Seguir</div> :
                                <div onClick={() => {
                                    setisSendFollow(true)
                                    startFollow(match.params.userID, relationBetween)
                                }} className="pointer">Seguir</div>
                            }
                            {isSendBlock ?
                                <div onClick={() => {
                                    setisSendBlock(false)
                                    unblockFriend(match.params.userID, relationBetween)
                                }} className="pointer">'Desbloquear'</div> :
                                <div onClick={() => {
                                    setisSendBlock(true)
                                    blockFriend(match.params.userID, relationBetween)
                                }} className="pointer">Bloquear</div>
                            }
                            {
                                        !isUserReported  && <div onClick={()=>{ 
                                            console.log()
                                            setIsShowReportPost(true)}} className="pointer">
                                            Reportar
                                        </div>
                                    }
                        </div>
                    </div>
                </div>
            </div>)
        }
    }, [isLoadingRelation, isSendFriend, isSendFollow, isSendBlock, isLoadingGetUserInfo])

    var contentModalOptions = <div></div>
    const setImageProfile = () => {
        if (userInfo && userInfo.picture) {
            const srcImge = userInfo.picture.url ? userInfo.picture.url.medium : userInfo.picture;

            return <img alt="img" className="img-profile" onError={(e) => e.target.src = circle} src={srcImge}></img>
        }
        return <img alt="img" className="img-profile" src={circle}></img>
    }


   

    var contentModal = <div className='modal-options'>
        <div onClick={(e) => selectPikerProfile(e)} className="modal-options-profile-picture">
            {Translate('changeProfilePicture', 'es')}
        </div>
    </div>

    if (!isLoadingGetUserInfo && userInfo && !userInfo.isEnabled)
        return (<div style={{ width: '100vw', alignItems: 'center', justifyContent: "center", display: 'flex', flexDirection: 'column', height: '80vh' }}>
            Este usuario a eliminado su cuenta
        </div>)

    if (isLoadingGetUserInfo || isLoadingRelation)
        return <div className="cargando"></div>

    return (
        <div className="content-profile">
             {isShowReportPost && <ModalReportContent
                                        displayModal={isShowReportPost} 
                                        closeModal={selectReportPost}
                                        postID={userID}
                                        history={history}
                                        isReportingUser={true}
                                    />}
            <div className="content-profile-img-icons">
                <div className="img-profile-content">
                    {setImageProfile()}
                    {/* {userInfo && userInfo.picture ? <img alt="img" className="img-profile" onError={(e) => e.target.src = circle} src={userInfo.picture}></img> :
                        <img alt="img" className="img-profile" src={circle}></img>
                    } */}
                    {userInfo && userInfo._id === localStorage().getItem("idUser") &&
                        <div className="add-profile-picture">
                            <ModalMenu
                                contentButton={<OptionsIcon className="cls-change-profile-picture pointer" height="15" width="35" />}
                                contentModal={contentModal}
                            />
                        </div>
                    }
                    <div className="column centerItems">
                        {userInfo && userInfo.rankID && userInfo.rankID.thumbnailImage && <img alt="img" className="pointer img-irn-rankin" onError={(e) => e.target.src = diammond} src={userInfo.rankID.thumbnailImage.url}></img>}
                        <div className="text-name-profile">{userInfo && userInfo.franchiseID.socialReason}</div>
                    </div>
                </div>
               
                <ModalPictureProfile
                    history={history}
                    displayModal={isShowPikerProfilePicture}
                    closeModal={selectPikerProfile}
                />
            </div>
            <div className="content-profile-tabs">
                
                <div>

                <div className="parent-width">
                    <div className="wrapper-1 column-gap-25">
                        <div className="row centerContent content-profile-info">
                            <div className="column centerItems">
                                <div className="text-name-profile"><Link to="/Inventory">Inventario</Link></div>
                            </div>
                            <div className="column centerItems">
                                <div className="text-name-profile"><Link to="/MarketPlace">MarketPlace</Link></div>
                            </div>
                            <div className="column centerItems">
                                {userInfo && userInfo.rankID && userInfo.rankID.thumbnailImage && <img alt="img" className="pointer img-irn-rankin" onError={(e) => e.target.src = diammond} src={userInfo.rankID.thumbnailImage.url}></img>}
                                <div className="text-name-profile">@{userInfo && userInfo.franchiseID.socialReason}</div>
                            </div>
                            <h3 className=" m-0 mt-2 mb-2">{Translate('textInformation', 'es')} </h3>
                            {userInfo && userInfo.franchiseID.ubication && userInfo.franchiseID.ubication.businessCountry && <div className="column centerItems mb-3">
                                <UbitacionIcon className="cls-1" height="18" width="18" />
                                <div className="column  text-information-profile ml-1">Pais actual: {userInfo.franchiseID.ubication.businessCountry}</div>
                            </div>}
                            {userInfo && userInfo.franchiseID.ubication && userInfo.franchiseID.ubication.businessDepartment && <div className="column centerItems mb-3">
                                <UbitacionIcon className="cls-1" height="18" width="18" />
                                <div className="column  text-information-profile ml-1">Departamento actual: {userInfo.franchiseID.ubication.businessDepartment}</div>
                            </div>}
                            {userInfo && userInfo.franchiseID.ubication && userInfo.franchiseID.ubication.businessCity && <div className="column centerItems mb-3">
                                <UbitacionIcon className="cls-1" height="18" width="18" />
                                <div className="column  text-information-profile ml-1">Ciudad actual: {userInfo.franchiseID.ubication.businessCity}</div>
                            </div>}
                            {userInfo && userInfo.franchiseID.ubication && userInfo.franchiseID.ubication.businessLocation && <div className="column centerItems mb-3">
                                <UbitacionIcon className="cls-1" height="18" width="18" />
                                <div className="column  text-information-profile ml-1">Barrio actual: {userInfo.franchiseID.ubication.businessLocation}</div>
                            </div>}
                            {userInfo && userInfo.franchiseID.ubication && userInfo.franchiseID.ubication.businessAddress && <div className="column centerItems mb-3">
                                <UbitacionIcon className="cls-1" height="18" width="18" />
                                <div className="column  text-information-profile ml-1">Direccion actual: {userInfo.franchiseID.ubication.businessAddress}</div>
                            </div>}
                            
                            {userInfo && userInfo.franchiseID.businessEmail && <div className="column centerItems mb-3">
                                <EmailIcon className="cls-1" height="18" width="18" />
                                <div className="column  text-information-profile ml-1">Correo empresarial: {userInfo.franchiseID.businessEmail}</div>
                            </div>}
                            {userInfo && userInfo.franchiseID.businessPhone && <div className="column centerItems mb-3">
                                <PhoneIcon className="cls-1" height="18" width="18" />
                                <div className="column  text-information-profile ml-1">Telefono empresarial: {userInfo.franchiseID.businessPhone}</div>
                            </div>}
                            

                        </div>
                        
                    </div>
                    
                </div>
                </div>
                {/* <Switch>
                    {routes.map((route, i) => (
                        <RouteWithSubRoutes key={i} {...route} />
                    ))}
                </Switch> */}
            </div>

        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        friendList: state.userInfo.friendList,
        userInfo: state.userInfo.userInfo,
        userCounters: state.userInfo.userCount,
        isUserReported: state.userInfo.reported,
        relationBetween: state.userInfo.relationBetween,
        isLoadingRelation: state.userInfo.isLoadingRelationBetween,
        isLoadingGetUserInfo: state.userInfo.isLoadingGetUserInfo
    }
}

export default connect(mapStateToProps, { seeFriendList, getUserInfo, getUserPost, getRelationBetween, addFriend, startFollow, stopFollow, acceptFriendRequest, cancelFriendRequest, deleteFriend, blockFriend, unblockFriend, reportUser })(Profile)